export default __webpack_public_path__ + "31948b4a5fc16ced5cb5a0f6f7858727.png";